import * as React from 'react'

import { Loader } from '@googlemaps/js-api-loader'
import { EnvironmentContext } from 'config/environment'

import { useEffect } from 'modules/core/hooks/useEffect'

type Props = {
  children?: React.ReactNode | undefined
  mapsEnabled?: boolean
}

type Data = {
  placesLibraryLoaded: boolean
  mapsLibraryLoaded: boolean
  markerLibraryLoaded: boolean
}

export const GoogleMapsProvider = ({ children, mapsEnabled }: Props) => {
  const [placesLibraryLoaded, setPlacesLibraryLoaded] = React.useState(false)
  const [mapsLibraryLoaded, setMapsLibraryLoaded] = React.useState(false)
  const [markerLibraryLoaded, setMarkerLibraryLoaded] = React.useState(false)
  const environment = React.useContext(EnvironmentContext)

  useEffect(() => {
    if (!mapsEnabled) return

    const loader = new Loader({
      apiKey: environment.googleMapsApiKey,
      version: 'weekly',
    })

    loader.importLibrary('places').then(() => setPlacesLibraryLoaded(true))
    loader.importLibrary('maps').then(() => setMapsLibraryLoaded(true))
    loader.importLibrary('marker').then(() => setMarkerLibraryLoaded(true))
  }, [mapsEnabled])

  return (
    <GoogleMapsContext.Provider
      value={{
        placesLibraryLoaded: placesLibraryLoaded,
        mapsLibraryLoaded: mapsLibraryLoaded,
        markerLibraryLoaded: markerLibraryLoaded,
      }}
    >
      {children}
    </GoogleMapsContext.Provider>
  )
}

const defaultData: Data = {
  placesLibraryLoaded: false,
  mapsLibraryLoaded: false,
  markerLibraryLoaded: false,
}

export const GoogleMapsContext = React.createContext<Data>(defaultData)
